var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChatGrey = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.5,
    height: 17.393,
    viewBox: "0 0 16.5 17.393",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3801",
    "data-name": "Group 3801",
    transform: "translate(-5.75 -12.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3802",
    "data-name": "Group 3802",
    transform: "translate(6 13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4374",
    "data-name": "Path 4374",
    d: "M7.868,16.893l-.059-.265c0-.009-.2-.891-.451-2.22C3.22,14.11,0,10.979,0,7.22,0,3.239,3.589,0,8,0s8,3.239,8,7.22a7.144,7.144,0,0,1-4.118,6.312A18.666,18.666,0,0,1,8.1,16.753ZM8,.39C3.8.39.39,3.454.39,7.22c0,3.6,3.137,6.589,7.143,6.808l.153.008.028.151c.181.961.336,1.706.417,2.083a18.6,18.6,0,0,0,3.484-3.025l.059-.045A6.762,6.762,0,0,0,15.61,7.22C15.61,3.454,12.2.39,8,.39",
    fill: "#b2b2b2",
    stroke: "#b2b2b2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4375",
    "data-name": "Path 4375",
    d: "M11.28,18.061a.78.78,0,1,1,.78-.78.78.78,0,0,1-.78.78",
    transform: "translate(-6.402 -10.061)",
    fill: "#b2b2b2",
    stroke: "#b2b2b2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4376",
    "data-name": "Path 4376",
    d: "M19.28,18.061a.78.78,0,1,1,.78-.78.78.78,0,0,1-.78.78",
    transform: "translate(-11.28 -10.061)",
    fill: "#b2b2b2",
    stroke: "#b2b2b2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4377",
    "data-name": "Path 4377",
    d: "M27.28,18.061a.78.78,0,1,1,.78-.78.78.78,0,0,1-.78.78",
    transform: "translate(-16.159 -10.061)",
    fill: "#b2b2b2",
    stroke: "#b2b2b2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChatGrey);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/chat-grey.1087f18fc8300339f27dfbf04c3bce05.svg";